import styled from '@emotion/styled';

export const TableContainer = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
`;
